import quickSpecs from './quickSpecs';
import attributesFromIDC from './attributesFromIDC';
import isElectric from './isElectric';
import vehicle from './vehicle';
import siteInfo from './siteInfo';

const root = {
	quickSpecs,
	attributesFromIDC,
	isElectric,
	vehicle,
	siteInfo
};

export default root;
